import React from "react";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { preset, reference } from "./reference.config";

const ReferenceManagement = () => {
  return (
    <Box>
      {/* Page Title Card */}
      <Card sx={{ mb: 3 }}>
        <Box
          sx={{
            backgroundColor: "#f8f9fa", // header-color
            px: 2,
            py: 1.5,
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Typography
            variant="h5"
            sx={{ color: "primary.main", fontWeight: 600, py: 1.5 }}
          >
            Reference Data Management
          </Typography>
        </Box>
      </Card>

      {/* Content Card */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={3} sx={{ py: 2 }}>
            {/* Left Column — Reference Data */}
            <Grid size={{ xs: 12, md: 6 }}>
              <Box sx={{ py: 1.5 }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Reference Data
                </Typography>
                <Typography sx={{ mt: 1 }}>
                  This allows you to make the system completely relevant for
                  your business.
                </Typography>
                <Typography sx={{ mt: 1 }}>Hints and Tips</Typography>
                <Box component="ul" sx={{ pl: 3, mt: 0.5 }}>
                  <li>
                    Keep lists as concise as possible and don&apos;t create too
                    many choices - make it easy for your carers
                  </li>
                </Box>
              </Box>

              {reference.map((item) => (
                <Box
                  key={item.id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid",
                    borderColor: "divider",
                    p: 0.5,
                    mb: 0.5,
                    borderRadius: 0.5,
                  }}
                >
                  <Typography
                    component={RouterLink}
                    to="#"
                    sx={{
                      mr: 1.5,
                      textDecoration: "none",
                      color: "primary.main",
                      "&:hover": { textDecoration: "underline" },
                    }}
                  >
                    {item.name}
                  </Typography>
                  <Typography sx={{ py: 0.5, ml: 1 }}>
                    {item.title}
                  </Typography>
                </Box>
              ))}
            </Grid>

            {/* Right Column — Pre-set Data */}
            <Grid size={{ xs: 12, md: 6 }}>
              <Box sx={{ py: 1.5 }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Pre-set Data
                </Typography>
                <Typography sx={{ mt: 1 }}>
                  Saving yourself time and effort and achieve consistency. This
                  allows you to set up pre-set text, checklists and actions
                  <br />
                  so that you can create high quality and consistent personal
                  centered care plans and actions.
                </Typography>
                <Typography sx={{ mt: 1 }}>Hints and Tips</Typography>
                <Box component="ul" sx={{ pl: 3, mt: 0.5 }}>
                  <li>
                    Insert a @ in the preset text - this will be replaced with
                    the Service Users name
                  </li>
                  <li>
                    Format the care plan text - make it easy to read and
                    highlight the Key points
                  </li>
                  <li>
                    Use a standard colour, such as Pink for items you need to
                    change for each resident
                  </li>
                </Box>
              </Box>

              {preset.map((item) => (
                <Box
                  key={item.id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid",
                    borderColor: "divider",
                    p: 0.5,
                    mb: 0.5,
                    borderRadius: 0.5,
                  }}
                >
                  <Typography
                    component={RouterLink}
                    to="#"
                    sx={{
                      mr: 1.5,
                      textDecoration: "none",
                      color: "primary.main",
                      display: "block",
                      "&:hover": { textDecoration: "underline" },
                    }}
                  >
                    {item.name}
                  </Typography>
                  <Typography sx={{ py: 0.5, display: "block" }}>
                    {item.title}
                  </Typography>
                </Box>
              ))}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ReferenceManagement;